import React, { useState } from 'react';
import { Box, AppBar, Toolbar, IconButton, Typography, Drawer, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import NavLinks from './NavLink';

const DRAWER_WIDTH = 240;
const COLLAPSED_DRAWER_WIDTH = 76;

const MainNavigation = ({ mode, onToggle, collapsed = false, onToggleCollapsed }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isDark = mode === 'dark';
  const drawerWidth = isDesktop && collapsed ? COLLAPSED_DRAWER_WIDTH : DRAWER_WIDTH;

  const handleDrawerToggle = () => setMobileOpen((prev) => !prev);

  const drawerContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <NavLinks
        collapsed={isDesktop && collapsed}
        onToggleCollapsed={isDesktop ? onToggleCollapsed : undefined}
        onClose={() => setMobileOpen(false)}
      />
    </Box>
  );

  return (
    <>
      {/* Mobile top bar */}
      {!isDesktop && (
        <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1 }}>
          <Toolbar>
            <IconButton color="inherit" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2 }}>
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" sx={{ fontFamily: '"Onest", sans-serif', fontWeight: 700, flexGrow: 1 }}>
              Horas
            </Typography>
            <IconButton color="inherit" onClick={onToggle} size="small">
              {isDark ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
            </IconButton>
          </Toolbar>
        </AppBar>
      )}

      {/* Desktop: permanent sidebar */}
      {isDesktop && (
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
              overflowX: 'hidden',
              transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.shorter
              })
            }
          }}>
          {drawerContent}
        </Drawer>
      )}

      {/* Mobile: temporary sidebar */}
      {!isDesktop && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            '& .MuiDrawer-paper': { width: DRAWER_WIDTH, boxSizing: 'border-box' }
          }}>
          {drawerContent}
        </Drawer>
      )}
    </>
  );
};

export default MainNavigation;
